module.exports = __webpack_public_path__ + "static/media/emily-bruner.d8357e84.svg";